import React from 'react';
import __ from 'lodash';
// sama dengan DropdownKelas, tetapi beda object responnya saja 
class DropdownKelasKapital extends React.Component{
    render(){
        return (
            this.props.kelas.map((val) =>  
                <option key={val.ID_KELAS} value={val.ID_KELAS}>{val.NAMA_KELAS}</option>
            )            
        )
    }
}

export default DropdownKelasKapital;